<ng-container class="w-40">
    @switch (layout) {
        @case ('vertical') {
            <div data-te-ripple-init
                 data-te-ripple-color="light">
                <a class="block" [routerLink]="productUrl">
                    <!-- Square box: product photos are square, and the space is reserved before they load. -->
                    <div class="relative max-w-md mx-auto overflow-hidden">
                        <app-image [class]="'block w-full aspect-square object-contain transform hover:scale-105 transition-transform duration-200'"
                                   [width]="400"
                                   [height]="400"
                                   [src]="product!.images[0]"
                                   [alt]="product!.altImages[0] || product!.name"></app-image>
                        @if (product?.discount) {
                            <span class="absolute top-1 left-1 rounded bg-red-600 px-1.5 py-0.5 text-xs sm:text-sm font-semibold text-white">&minus;{{ discountPercent }}%</span>
                        }
                    </div>
                    <p class="font-medium text-center text-xs sm:text-base pt-1 line-clamp-2 min-h-[2lh]"
                       [title]="product!.name">{{ product!.name }}</p>
                    <div class="flex justify-center pt-1">
                        <app-text
                                [ngClass]="(product?.discount)? 'text-red-600': ''"
                                class="text-center text-xs sm:text-base"
                                [value]="product?.price?.toString() + ' ден.'"></app-text>
                        @if (product?.discount) {
                            <app-text class="text-center line-through pl-1.5 text-gray-500 text-xs sm:text-base"
                                      [value]="product?.originalPrice?.toString() + ' ден.'"></app-text>
                        }

                    </div>
                </a>
                @if (showAddToCartButton) {
                    <app-primary-button [value]="'Додади во кошничка'"
                                        (click)="goToUrl(router, productUrl)"
                                        class="flex text-xs sm:text-base mx-auto"></app-primary-button>
                }
                @if (auth.user$ | async; as user) {
                    @if (user.email === environment.admin) {
                        <app-secondary-button [value]="'Уреди'"
                                              class="pt-2 flex mx-auto text-xs sm:text-base"
                                              (click)="goToUrl(router, 'shop/product/' + product?.id + '/edit')"
                        ></app-secondary-button>
                    }
                }
            </div>
        }
        @case ('horizontal') {
            <div>
                <div class="lg:flex justify-between">
                    <div class="flex">
                        @if (orderItem) {
                            <app-image [class]="'w-32 lg:w-44'"
                                       [src]="orderItem.product!.images[0]"
                                       [alt]="orderItem.product!.altImages[0] || orderItem.product!.name"></app-image>
                        }
                        <div class="text-left pl-5 lg:my-auto lg:text-base">
                            <app-text class="lg:text-2xl font-medium text-left"
                                      [value]="orderItem?.product?.name"></app-text>
                            <app-text [value]="orderItem?.product?.price + ' ден.'"></app-text>
                        </div>
                    </div>
                    <div class="flex grid-cols-2 gap-7">
                        <div class="grid my-auto">
                            <app-quantity-selector
                                    (quantityChange)="onQuantityChange($event)"
                                    [quantity]="quantity"
                                    [control]="quantityControl"></app-quantity-selector>
                            <button class="text-sm text-left lg:text-center underline px-2"
                                    (click)="emitRemoveItemEvent()">Oтстрани
                            </button>
                        </div>
                        @if (orderItem && orderItem.product && orderItem.quantity) {
                            <app-text class="hidden lg:flex lg:text-right my-auto text-2xl"
                                      [value]="orderItemPrice + ' ден.'"></app-text>
                        }
                    </div>
                </div>
            </div>
        }
    }
</ng-container>
